import type { ContentObject } from 'models';
import { Text } from 'ui';

export type LikeButtonType = 'action' | 'count';

type P = {
  contentObject: ContentObject;
  type: LikeButtonType;
};

const LikeButtonContent = ({ contentObject, type }: P) => {
  if (type === 'count') {
    return contentObject.likesCount;
  }

  if (contentObject.liked) {
    return <Text type="danger">Like</Text>;
  }

  return 'Like';
};

export default LikeButtonContent;
